import {Controller} from "@hotwired/stimulus"
import {Modal} from "bootstrap"


export default class extends Controller {
    static values = {
        url: String,
        key: String
    }

    connect() {
        const pb = this.paint_button;
        pb(this.keyValue, this)
    }

    paint_button(ckey, target) {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        params.forEach((value, key) => {
            var [pkey, ptype] = key.split('.')
            if (pkey === ckey) {
                if (ptype === "sort_direction") {
                    switch (value) {
                        case "asc":
                            target.element.classList.add("caption-filter-asc")
                            target.element.classList.remove("caption-filter-desc")
                            target.element.classList.remove("caption-filter-no")
                            break;
                        case "desc":
                            target.element.classList.add("caption-filter-desc")
                            target.element.classList.remove("caption-filter-asc")
                            target.element.classList.remove("caption-filter-no")
                            break;
                    }
                } else {
                    // console.log(target);
                    if (value) {
                        target.element.classList.remove("caption-filtered-no")
                        target.element.classList.add("caption-filtered")
                    } else {
                        target.element.classList.add("caption-filtered-no")
                        target.element.classList.remove("caption-filtered")
                    }
                }
            }
        })
    }

    toggle_form(e) {
        const url = new URL(window.location.origin + window.location.pathname + "/c_forms");
        url.searchParams.set("key", this.keyValue);
        const pb = this.paint_button;
        fetch(url, {
            headers: {
                Accept: "text/vnd.turbo-stream.html",
            },
        }).then(r => r.text())
            .then(html => Turbo.renderStreamMessage(html))
            .then(pb(this.keyValue, this))

    }
}